import { render } from "./TutorialVideo.vue?vue&type=template&id=4f8b87aa"
import script from "./TutorialVideo.vue?vue&type=script&lang=js"
export * from "./TutorialVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__